<template>
  <v-container fluid class="menu">
    <v-layout row wrap>
      <v-flex
              v-for="(screen, i) in screens"
              :key="i"
              class="menu-box"
              :style="'background: url(' + screen.img + ')'"
              xs12
              md6
      >

        <a :href="screen.url">

        <div
                class="menu-box-mask"
        >
          <div class="menu-box-text">

            <h1 class="menu-box-title">&#171;{{screen.title}}&#187;</h1>
            <h2 class="menu-box-subtitle">{{screen.subtitle}}</h2>
            <div class="menu-box-address">{{screen.address}}</div>

            <a
                    :href="screen.url"
                    class="menu-box-btn"
            >Подробнее</a>

            <!--
            <v-btn
                    class="menu-box-btn"
                    :color="colors.buttons.success"
                    :to="screen.url"
                    round
            ><span :style="'color: ' + colors.white">Подробнее</span></v-btn>
            -->
          </div>
        </div>

        </a>

      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
export default {
  data () {
    return {
      screens: [
        {
          title: 'Малина',
          subtitle: 'Сауна и гостиница',
          address: 'Щорса, 5а к4',
          url: '/malina',
          img: '/static/img/home/malina/1.jpg'
        },
        {
          title: 'Садко',
          subtitle: 'Сауна',
          address: 'Орджоникидзе, 28а',
          url: '/sadko',
          img: '/static/img/home/sadko/home1.jpg'
        }
        // {
        //   title: 'Акрополь',
        //   subtitle: 'Сауна и кафе',
        //   address: 'Орджоникидзе, 13',
        //   url: '/acropolis',
        //   img: '/static/img/home/acropolis/home1.jpg'
        // }
      ]
    }
  },
  computed: {
    colors () {
      return this.$store.getters.colors
    }
  }
}
</script>

<style scoped>
  .menu {
    padding: 0;
  }

  .menu-box {
    position: relative;
    height: calc(100vh - 64px);
    /*border: 1px solid #000000;*/
    text-align: center;
    background-position: center !important;
    background-repeat: no-repeat !important;
    background-size: auto 100% !important;
  }

  .menu-box:hover {
    background-size: auto 110% !important;
    transition: 1s;
  }

  .menu-box-mask {
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    /*background-color: rgba(255, 255, 255, .3);*/
    background-color: rgba(0, 0, 0, .4);
  }

  .menu-box-text {
    color: #ffffff;
  }

  .menu-box-title {
    margin-top: 30vh;
  }

  .menu-box-subtitle {
    margin: 5px 0 10px 0;
  }

  .menu-box-address {
    font-size: 18px;
    margin-bottom: 15px;
  }

  .menu-box-btn {
    color: #ffffff;
    border-bottom: 1px dotted #ffffff;
  }

  .menu-box-btn:hover {
    border-bottom: none;
  }

  /* MEDIA */
  /* EXTRA SMALL */
  @media (max-width: 600px) {
    .menu-box-title {
      margin-top: calc(100vh * 0.12 / 3) !important;
    }
  }

  /* SMALL */
  @media (max-width: 960px) {
    .menu-box {
      height: calc((100vh - 48px) / 3);
      background-position: center !important;
      background-repeat: no-repeat !important;
      background-size: 100% auto !important;
    }

    .menu-box:hover {
      background-size: 110% auto !important;
      transition: 1s;
    }

    .menu-box-title {
      margin-top: calc(100vh * 0.17 / 3);
      font-size: 20px;
    }

    .menu-box-subtitle {
      margin: 10px 0 5px 0;
      font-size: 14px;
    }

    .menu-box-address {
      font-size: 14px;
      margin-bottom: 10px;
    }

  }

  /* MEDIUM */
  @media (max-width: 1264px) {

  }

  /* LARGE */
  @media (max-width: 1904px) {

  }

  /* X LARGE */
  @media (min-width: 1904px) {

  }
</style>



// WEBPACK FOOTER //
// src/components/pages/Home.vue